<template>
  <div>
    <Calendar />
  </div>
</template>

<script>
import Calendar from "@/components/Dashboard/Calendar/Calendar";

export default {
  components: {
    Calendar
  }
};
</script>

<style>
@media (min-width: 360px) and (max-width:767px) {
  .v-chip--removable .v-chip__content {
    padding: 0 6px !important;
  }
  .v-calendar-weekly__day-month {
    left: 45%;
  }
}
@media (min-width: 320px) and (max-width:359px) {
  .ma-2 {
    width: 90%;
    margin: 0% !important;
  }
  .v-chip__content {
    padding-left: 0 !important;
  }
  .v-calendar-weekly__day-month {
    top: auto;
    left: auto;
  }
}
</style>